import addNewStudent from 'html/layouts/add-new-student.html';
import App from 'app/app.js';
import 'app/directive/LtInstantPromoPopupCtrl.js';

function LtAddNewStudentDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      goHome: '&',
      openStudentTab: '='
    },
    template: addNewStudent,
    controller: 'LtAddNewStudentCtrl',
    controllerAs: 'addNewStudent'
  };
}

App.directive('ltAddNewStudent', [LtAddNewStudentDirective]);
